var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Model",
    {
      attrs: {
        form: _vm.form,
        "init-form": _vm.initForm,
        "is-show": _vm.isShowModel,
        "dialog-status": _vm.dialogStatus,
        "save-item": _vm.saveItem,
        "destroy-on-close": true,
      },
      on: {
        "update:isShow": function ($event) {
          _vm.isShowModel = $event
        },
        "update:is-show": function ($event) {
          _vm.isShowModel = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: { model: _vm.form, rules: _vm.rules, size: "small" },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "appPlatformType",
                label: _vm.appParent.keyMapping("appPlatformType"),
                "label-width": _vm.formLabelWidth,
              },
            },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", disabled: "" },
                  model: {
                    value: _vm.form.appPlatformType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "appPlatformType", $$v)
                    },
                    expression: "form.appPlatformType",
                  },
                },
                _vm._l(
                  _vm.appParent.appPlatformTypeList,
                  function (item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: { label: item.valueName, value: item.valueCode },
                    })
                  }
                ),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "displayVersion",
                label: _vm.appParent.keyMapping("displayVersion"),
                "label-width": _vm.formLabelWidth,
              },
            },
            [
              _c("el-input", {
                attrs: { autocomplete: "off" },
                model: {
                  value: _vm.form.displayVersion,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "displayVersion", $$v)
                  },
                  expression: "form.displayVersion",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.brand === "ANDROID"
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "downloadUrl",
                    label: this.$t("sfe.appVersion.table.appPlatformType"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c(
                    "el-upload",
                    {
                      attrs: {
                        action: "",
                        "auto-upload": false,
                        limit: 1,
                        "show-file-list": false,
                        "on-remove": _vm.handleRemove_apk,
                        "on-change": _vm.handleChange_apk,
                        "file-list": _vm.fileList,
                      },
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", type: "primary" } },
                        [_vm._v(_vm._s(_vm.$t("sfe.appVersion.button.upload")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }